export default __webpack_public_path__ + "38d8bea604cda9db59c0613ffd6aecb6.woff2";